/* eslint-disable */
import React, { useState } from 'react';
import { useStateValue } from '../ContextApi/StateProvider';
import './components.css';
import { Redirect } from 'react-router-dom';
import Form from './Form';

const NewWorkout = (props) => {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [errors, setErrors] = useState([]);
    const [initialState] = useStateValue();
    const authUser = JSON.parse(initialState.authenticatedUser);

    const change = (event, setState) => {
        const value = event.target.value;
        setState(value);
    };

    const submit = () => {
        const date = new Date();
        const days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
        const day = days[date.getDay()];
        const fullDate = `${day}, ${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        const workout = { title, description, time: fullDate };

        initialState.WorkoutRequests.createWorkout(workout, authUser.emailAddress, authUser.password)
            .then((response) => {
                if (response === "success") {
                    console.log(`${authUser.emailAddress} has successfully created workout ${workout}`);
                    props.history.push('/home');
                } else if (response === "forbidden") {
                    setErrors([...errors, "You must be logged in to create a workout."]);
                } else {
                    setErrors([...errors, response]);
                    console.log(errors);
                }
            })
            .catch(err => setErrors([...errors, err]));
    };

    const cancel = () => props.history.push('/home');

    if (!authUser) {
        return <Redirect to="/sign-in" />;
    }

    return (
        <div className="container-2025 section-2025 prose-2025">
            <div className="grid-2025">
                <Form 
                    cancel={cancel}
                    cancelButtonText="Back"
                    submit={submit}
                    submitButtonText="Create Workout"
                    elements={() => (
                        <>
                            <h2 className="form-header">
                                <i className="fas fa-newspaper"></i> Create Workout
                            </h2>
                            {errors.map((error, i) => (
                                <p key={i} className="new-workout-error-message">{error}</p>
                            ))}

                            <div className="form-row">
                                <label htmlFor="title" className="form-label">Title</label>
                                <input
                                    id="title"
                                    name="title"
                                    type="text"
                                    onChange={(e)=> change(e, setTitle)} 
                                    placeholder={title}
                                    maxLength="18"
                                    required
                                    className="input-2025"
                                />
                            </div>

                            <div className="form-row">
                                <label htmlFor="description" className="form-label">Description</label>
                                <input
                                    id="description"
                                    name="description"
                                    type="text"
                                    onChange={(e)=> change(e, setDescription)} 
                                    placeholder={description}
                                    required
                                    className="input-2025"
                                />
                            </div>
                        </>
                    )}
                />
            </div>  
        </div>
    );
};

export default NewWorkout;